import React from "react";
import { RouteService } from "../Services/RouteService";
import {GoogleApiWrapper, Map, Polygon, Marker} from 'google-maps-react';

class MapContainer extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            routes: [],
        }
        this.generateColor = this.generateColor.bind(this);
    }

    componentWillMount(){
        RouteService.getRouteAreaCoordinates()
        .then((data) => {
            console.log(data);
            let routes = [];
            data.forEach(element => {
                element.color = this.generateColor();
                let center = {};
                let lngs = [], lats = [];
                element.points.forEach((p) =>{
                    lats.push(p.lat);
                    lngs.push(p.lng);
                });
                lats.sort();
                lngs.sort();
                center.lat = lats[0] + ((lats[lats.length - 1]-lats[0]) / 2);
                center.lng = lngs[0] + ((lngs[lngs.length - 1]-lngs[0]) / 2);
                console.log(center);
                routes.push(<Polygon key={element.name}
                                paths={element.points}
                                strokeColor={element.color}
                                strokeOpacity={0.8}
                                strokeWeight={2}
                                fillColor={element.color}
                                fillOpacity={0.35} />);
                routes.push(<Marker 
                                key={`${element.name}_marker`}
                                title={element.name}
                                name={element.name}
                                position={center}/>);
                                
            });
            this.setState({routes: routes});
        })
        .catch(()=>{
            console.log("error while fetching data");
        })
    }

    generateColor() {
        return 'rgb(' + (Math.floor(Math.random() * 256)) + ',' + (Math.floor(Math.random() * 256)) + ',' + (Math.floor(Math.random() * 256)) + ')';
    }

    render() { 
        return (

            <Map google={this.props.google}
                style={{width: '80%', height: '80%', position: 'relative'}}
                className="map"
                initialCenter = {{ lat: 12.9542946, lng: 77.4908525 }}
                zoom={11}>
                {this.state.routes}
            </Map>
        );
      }
}
 
export default GoogleApiWrapper({
  apiKey: ('AIzaSyBntObos_tYkS4o0ZU13KhopK0iUQTLnDI')
//   apiKey: ('AIzaSyAyesbQMyKVVbBgKVi2g6VX7mop2z96jBo')
})(MapContainer);